import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal } from "@/components/Motion";

export const ServiceCard = ({ s, i }) => {
  const { lp, t } = useLang();
  return (
    <Reveal delay={(i % 3) * 0.08} className="h-full">
      <Link to={lp(`/services/${s.slug}`)} data-testid={`service-card-${s.slug}`} className="svc-card group flex h-full flex-col bg-white p-6 sm:p-8">
        <div className="relative aspect-[4/3] overflow-hidden bg-[#0F2138]">
          <img src={s.img} alt={s.title} loading="lazy" className="svc-img h-full w-full object-cover" />
          <span className="absolute start-0 top-0 bg-white px-3 py-2 font-serif text-sm text-[#1E3A5F]" dir="ltr">{String(i + 1).padStart(2, "0")}</span>
        </div>
        <div className="flex flex-1 flex-col pt-7">
          <h3 className="font-serif text-2xl leading-snug text-[#1E3A5F]">{s.title}</h3>
          <p className="mt-3 flex-1 text-[0.95rem] leading-relaxed text-[#4A5D75]">{s.short}</p>
          <span className="mt-6 inline-flex items-center gap-2 border-t border-[#8EA3BC]/40 pt-5 text-sm font-semibold text-[#1E3A5F]">
            {t.common.learnMore}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 rtl:-scale-x-100 rtl:group-hover:-translate-x-0.5" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
};

export const ServicesGrid = () => {
  const { t } = useLang();
  return (
    <div className="grid gap-px border border-[#8EA3BC]/40 bg-[#8EA3BC]/40 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
      {t.services.map((s, i) => <ServiceCard key={s.slug} s={s} i={i} />)}
    </div>
  );
};
